
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/svetainiu-programavimas",
      function () {
        return require("private-next-pages/lt/svetainiu-programavimas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/svetainiu-programavimas"])
      });
    }
  